import React from 'react';
import styles from './Header.module.css';

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.badge}>JS</div>
        <div>
          <h1 className={styles.title}>Playground</h1>
          <p className={styles.subtitle}>Ejercicios técnicos — Estadías profesionales</p>
        </div>
      </div>
    </header>
  );
}

export default Header;
